import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Reservation() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setShowToast(true);
      // Hide toast after 5 seconds
      setTimeout(() => {
        setShowToast(false);
      }, 5000)
      // Reset form
;
      (e.target as HTMLFormElement).reset();
    }, 1500);
  };
  return <section id="reservation" className="py-32 bg-dark relative" dir="rtl" data-id="element-106">
      <div className="container mx-auto px-6 md:px-12" data-id="element-107">
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row gap-16 lg:gap-24" data-id="element-108">
          {/* Info Side */}
          <motion.div className="w-full lg:w-5/12 flex flex-col" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} data-id="element-109">
            <h2 className="font-serif text-5xl text-cream mb-8" data-id="element-110">הזמנת מקום</h2>
            <p className="font-sans text-cream/70 text-lg mb-12 leading-relaxed" data-id="element-111">
              אנו מזמינים אתכם לחוויה קולינרית ייחודית. אנא מלאו את הפרטים
              ונחזור אליכם לאישור ההזמנה בהקדם.
            </p>

            <div className="space-y-8 font-sans" data-id="element-112">
              <div data-id="element-113">
                <h4 className="text-gold text-sm uppercase tracking-widest mb-2" data-id="element-114">
                  שעות פעילות
                </h4>
                <p className="text-cream/80" data-id="element-115">ראשון - חמישי: 18:00 - 23:30</p>
                <p className="text-cream/80" data-id="element-116">
                  שישי - שבת: 12:00 - 15:30, 19:00 - 24:00
                </p>
              </div>

              <div data-id="element-117">
                <h4 className="text-gold text-sm uppercase tracking-widest mb-2" data-id="element-118">
                  יצירת קשר
                </h4>
                <p className="text-cream/80" dir="ltr" data-id="element-119">
                  03-529-7700
                </p>
                <p className="text-cream/80" data-id="element-120">רחוב לילינבלום 14, תל אביב</p>
              </div>
            </div>
          </motion.div>

          {/* Form Side */}
          <motion.div className="w-full lg:w-7/12" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-121">
            <form onSubmit={handleSubmit} className="space-y-8" data-id="element-122">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-123">
                <div className="relative border-b border-white/20 focus-within:border-gold transition-colors" data-id="element-124">
                  <input type="text" required placeholder="שם מלא" className="w-full bg-transparent py-3 text-cream placeholder-cream/30 focus:outline-none font-sans" data-id="element-125" />
                </div>
                <div className="relative border-b border-white/20 focus-within:border-gold transition-colors" data-id="element-126">
                  <input type="tel" required placeholder="טלפון" className="w-full bg-transparent py-3 text-cream placeholder-cream/30 focus:outline-none font-sans" data-id="element-127" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-128">
                <div className="relative border-b border-white/20 focus-within:border-gold transition-colors" data-id="element-129">
                  <input type="date" required className="w-full bg-transparent py-3 text-cream focus:outline-none font-sans [color-scheme:dark]" data-id="element-130" />
                </div>
                <div className="relative border-b border-white/20 focus-within:border-gold transition-colors" data-id="element-131">
                  <select required className="w-full bg-transparent py-3 text-cream focus:outline-none font-sans appearance-none" data-id="element-132">
                    <option value="" disabled selected className="text-espresso" data-id="element-133">
                      מספר סועדים
                    </option>
                    {[1, 2, 3, 4, 5, 6, 7, 8].map(num => <option key={num} value={num} className="text-espresso" data-id="element-134">
                        {num} סועדים
                      </option>)}
                    <option value="more" className="text-espresso" data-id="element-135">
                      9+ סועדים (אירוע)
                    </option>
                  </select>
                </div>
              </div>

              <div className="pt-4" data-id="element-136">
                <button type="submit" disabled={isSubmitting} className="w-full md:w-auto bg-gold text-espresso px-12 py-4 font-sans text-sm uppercase tracking-widest hover:bg-cream transition-colors duration-300 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-137">
                  {isSubmitting ? 'שולח...' : 'שלח בקשה'}
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      </div>

      {/* Success Toast */}
      <AnimatePresence data-id="element-138">
        {showToast && <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 50
      }} className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 bg-espresso border border-gold px-8 py-4 shadow-2xl flex items-center gap-4" data-id="element-139">
            <span className="font-serif text-gold text-xl" data-id="element-140">תודה!</span>
            <span className="font-sans text-cream" data-id="element-141">
              בקשת ההזמנה התקבלה. ניצור קשר בקרוב.
            </span>
          </motion.div>}
      </AnimatePresence>
    </section>;
}